import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

// Reusable Designer Payment & Payout Policy content. Used both as a read-only view
// ("View Payout Policy") and as an acceptance gate before the designer's first
// application. Never uses the word "escrow" in user-facing text.
export const PayoutPolicyContent = () => {
  const { t } = useTranslation();
  const points = t("payoutPolicy.points", { returnObjects: true });
  const list = Array.isArray(points) ? points : [];
  return (
    <div className="space-y-3 text-sm text-muted-foreground" data-testid="payout-policy-content">
      <p>{t("payoutPolicy.intro")}</p>
      <ul className="list-disc space-y-1.5 pl-5">
        {list.map((p, i) => (
          <li key={i}>{p}</li>
        ))}
      </ul>
      <p className="text-xs">{t("payoutPolicy.version")}: <span className="font-mono">designer-payout-v1.0</span></p>
    </div>
  );
};

// mode: "view" (just read) | "accept" (checkbox + confirm button)
export default function PayoutPolicyDialog({ open, onOpenChange, mode = "view", onAccept, busy }) {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);

  return (
    <Dialog open={open} onOpenChange={(o) => { setChecked(false); onOpenChange?.(o); }}>
      <DialogContent className="max-w-lg bg-white" data-testid="payout-policy-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-brand" /> {t("payoutPolicy.title")}
          </DialogTitle>
        </DialogHeader>
        <div className="max-h-[55vh] overflow-y-auto pr-1">
          <PayoutPolicyContent />
        </div>
        {mode === "accept" && (
          <div className="space-y-3 border-t border-border pt-3">
            <label className="flex cursor-pointer items-start gap-2 text-sm" data-testid="payout-policy-gate-checkbox-label">
              <input
                type="checkbox"
                className="mt-0.5 h-4 w-4 rounded border-slate-300"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
                data-testid="payout-policy-gate-checkbox"
              />
              <span>{t("payoutPolicy.accept")}</span>
            </label>
            <Button
              className="w-full rounded-full bg-brand text-white hover:bg-brand/90"
              disabled={!checked || busy}
              onClick={() => onAccept?.()}
              data-testid="payout-policy-gate-confirm"
            >
              {t("payoutPolicy.acceptContinue")}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
